/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  BsFacebook,
  BsMailbox,
  BsMessenger,
  BsPhone,
} from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import { FaInstagram, FaTelegramPlane, FaViber } from "react-icons/fa";
const ContactUs = () => {
  return (
    <div className="bg-[#FFF9F4]">
      <div className="px-20 py-[3.2rem]">
        <div className="flex justify-center flex-col items-center gap-4 mb-10">
          <h2 className="text-[24px] font-bold text-center">Contact Us</h2>
          {/* <div className="w-28 h-[2px] bg-black"></div> */}
        </div>
        <div className="flex flex-col justify-center items-center gap-8 text-black">
          <div className="w-[350px] flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div>
                <GoLocation />
              </div>
              <div>
              No. 34, Padauk Myaing, Kabaraye Pagoda Road, Mayangone Township, Yangon, Myanmar. 
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div>
                <BsMailbox />
              </div>
              <div>fitbaemyanmar@gmail.com</div>
            </div>
            <div className="flex items-center gap-4">
              <div>
                <BsPhone />
              </div>
              <div>09405788393</div>
            </div>
          </div>
          <div className="flex justify-center items-center gap-8">
            <a href="https://www.facebook.com/FIT.baemyanmar">
              <BsFacebook size={24} />
            </a>
            <a href="https://m.me/FIT.baemyanmar">
              <BsMessenger size={24} />
            </a>
            <a href="https://www.instagram.com/fit.bae_mm/">
              <FaInstagram size={24} />
            </a>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
